const explanations: Record<string, string> = {
  unknown_feed_coverage: "Spend feed coverage is unknown.",
  missing_total_amount: "Total contract amount is missing.",
  missing_annual_amount: "Annual contract amount is missing.",
  missing_currency: "Contract currency is missing.",
  insufficient_confirmed_spend_watermark:
    "Confirmed spend watermark does not cover the required valuation date for this reporting period.",
  missing_confirmed_spend_watermark: "Confirmed spend watermark is missing.",
  valuation_unavailable_for_period: "A valuation date is unavailable for this future reporting period.",
  missing_rate_for_valuation_date: "No approved exchange rate covers the estimate valuation date.",
};
export const estimateReason = (code: string) => explanations[code] ?? "Estimate coverage requires review.";
